import {useEffect} from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';

const dontScrollIntoViewOnPaths = [
  // '/riac-blog', '/news', '/news-and-events'
];

// Component to scroll to top of page when route changes.
const ToTop = ({history, location}) => {

  useEffect(() => {
    let {hash, pathname} = location;

    if (history.action === 'POP') {
      if (!dontScrollIntoViewOnPaths.includes(pathname)) {
        window.scrollTo(0, 0);
      }
      return;
    }

    if (hash) {
      let element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({block: 'start', behavior: 'smooth'});
      }
    } else if (!dontScrollIntoViewOnPaths.includes(pathname)) {
      window.scrollTo(0, 0);
    }
  }, [location.hash, location.pathname, history.action]);

  return (null);
};

export const ScrollToTop: React.ComponentClass<Pick<RouteComponentProps<any, unknown, unknown>, never>, any> = withRouter(ToTop);
